import { render } from "./MainGiaoThongThongMinh.vue?vue&type=template&id=652d94ff"
import script from "./MainGiaoThongThongMinh.vue?vue&type=script&lang=js"
export * from "./MainGiaoThongThongMinh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__